module.exports = __webpack_public_path__ + "img/img3.59770106.png";